const STORAGE_KEY = 'preformiq_training_prefs';

export type TrainingPrefs = {
  daysPerWeek: number | null;
  preferredWorkoutDays: number[];
  autoRestTimer: boolean;
  restTimerSeconds: number;
  defaultRpeTracking: boolean;
  advancedMetrics: boolean;
  preferredSplit: string;
  workoutDurationMin: number | null;
  trainingLocation: 'gym' | 'home' | null;
};

export const DEFAULT_TRAINING_PREFS: TrainingPrefs = {
  daysPerWeek: 4,
  preferredWorkoutDays: [1, 2, 4, 5],
  autoRestTimer: true,
  restTimerSeconds: 90,
  defaultRpeTracking: false,
  advancedMetrics: false,
  preferredSplit: '',
  workoutDurationMin: 60,
  trainingLocation: 'gym',
};

function storageKey(userId: string | undefined): string {
  return userId ? `${STORAGE_KEY}:${userId}` : STORAGE_KEY;
}

export function getTrainingPrefs(userId?: string): TrainingPrefs {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return { ...DEFAULT_TRAINING_PREFS };
    return { ...DEFAULT_TRAINING_PREFS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_TRAINING_PREFS };
  }
}

export function setTrainingPrefs(userId: string | undefined, prefs: Partial<TrainingPrefs>) {
  const next = { ...getTrainingPrefs(userId), ...prefs };
  localStorage.setItem(storageKey(userId), JSON.stringify(next));
  return next;
}

export function isPreferredWorkoutDay(date: Date, prefs: TrainingPrefs): boolean {
  if (prefs.preferredWorkoutDays.length === 0) return true;
  return prefs.preferredWorkoutDays.includes(date.getDay());
}

export function isScheduledRecoveryDay(
  planRestDay: boolean,
  prefs: TrainingPrefs,
  date = new Date(),
): boolean {
  if (planRestDay) return true;
  if (prefs.preferredWorkoutDays.length > 0) {
    return !prefs.preferredWorkoutDays.includes(date.getDay());
  }
  return false;
}

export const WEEKDAY_LABELS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;
